module.exports = __webpack_public_path__ + "static/media/eat-food-healthy-life-svgrepo-com.3dbeab08.svg";